module.exports = __webpack_public_path__ + "static/media/iconProyecto.e4a9a98f.svg";